import { _keys, BadImplementationException, tsValidate, tsValidateArray, tsValidateBoolean, tsValidateCustom, tsValidateResult, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { FHIRResourceSubTypeParamType_Dynamic, FHIRResourceSubTypeParamType_Fixed } from './types.js';
const Validator_FHIRResourceSubTypeParam_Base = {
    param: tsValidateString(),
    isMultiValue: tsValidateBoolean(),
    isOptional: tsValidateBoolean(),
    isPostFiltered: tsValidateBoolean(),
    description: tsValidateString(-1, false),
};
export const Validator_FHIRResourceSubTypeParamValue = {
    value: tsValidateString(),
    label: tsValidateString(-1, false),
};
const ParamValidator = {
    [FHIRResourceSubTypeParamType_Dynamic]: {
        ...Validator_FHIRResourceSubTypeParam_Base,
        type: tsValidateValue([FHIRResourceSubTypeParamType_Dynamic]),
    },
    [FHIRResourceSubTypeParamType_Fixed]: {
        ...Validator_FHIRResourceSubTypeParam_Base,
        type: tsValidateValue([FHIRResourceSubTypeParamType_Fixed]),
        values: tsValidateArray(Validator_FHIRResourceSubTypeParamValue),
    }
};
const Validator_Param = (param) => {
    if (!param)
        return 'Got no param';
    switch (param.type) {
        case FHIRResourceSubTypeParamType_Fixed:
            return tsValidate(param, ParamValidator[FHIRResourceSubTypeParamType_Fixed]);
        case FHIRResourceSubTypeParamType_Dynamic:
            return tsValidate(param, ParamValidator[FHIRResourceSubTypeParamType_Dynamic]);
        default:
            // @ts-ignore
            return `Unknown param type ${param.type}`;
    }
};
export const Validator_FHIRResourceSubTypes = (subTypes, resource) => {
    if (!resource)
        throw new BadImplementationException('Must pass resource to validate the sub-types');
    const validateGroupParams = (groupParams) => {
        const currentGroupParamKeys = _keys(groupParams);
        const resourceGroupParamsThatAreMissing = resource.groupParams.filter((groupParam) => !currentGroupParamKeys.includes(groupParam.param));
        const groupParamsNotInResource = currentGroupParamKeys.filter(key => !resource.groupParams.find((groupParam) => groupParam.param === key));
        //Check no missing group params
        if (resourceGroupParamsThatAreMissing.length)
            return resourceGroupParamsThatAreMissing.reduce((map, key) => {
                map[key] = 'Missing Group Param';
                return map;
            }, {});
        //Check group params that are not in the resource
        if (groupParamsNotInResource.length)
            return groupParamsNotInResource.reduce((map, key) => {
                map[key] = 'Unexpected Group Param';
                return map;
            }, {});
        const results = currentGroupParamKeys.reduce((map, key) => {
            const isMulti = resource.groupParams.find((group) => group.param === key).isMultiValue;
            map[key] = isMulti ? tsValidateResult(groupParams[key], tsValidateArray(Validator_FHIRResourceSubTypeParamValue)) : tsValidateResult(groupParams[key], Validator_FHIRResourceSubTypeParamValue);
            return map;
        }, {});
        //Clear unused keys
        _keys(results).forEach(key => {
            if (!results[key])
                delete results[key];
        });
        return _keys(results).length ? results : undefined;
    };
    return tsValidate(subTypes, tsValidateArray({
        key: tsValidateString(),
        label: tsValidateString(),
        // @ts-ignore
        params: tsValidateArray(Validator_Param),
        description: tsValidateString(-1, false),
        // @ts-ignore
        groupParams: tsValidateCustom(groupParams => validateGroupParams(groupParams)),
    }));
};
//# sourceMappingURL=validator.js.map